<template>
  <header class="dashboard-header">
    <div class="container-cls">
      <router-link :to="{ path: '/' }" class="dashboard-logo">
        <img
          src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png"
          alt
        />
      </router-link>
    </div>
  </header>
</template>
<script>
export default {
  name: "FrontHeader"
};
</script>
